export default __webpack_public_path__ + "static/media/ratheg1.129d7344.png";